import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './remove-habit-schedule.style';

export type RemoveHabitScheduleMessageProps = {
  name: string;
  onSubmit: () => void;
  onCancel: () => void;
};

export const RemoveHabitScheduleMessage: React.FC<
  RemoveHabitScheduleMessageProps
> = ({ name, onSubmit, onCancel }) => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t('forms.remove-habit-schedule.message.title')}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">
          {t('forms.remove-habit-schedule.message.description.1')}
          <Styled.HabitName>{name}</Styled.HabitName>
          {t('forms.remove-habit-schedule.message.description.2')}
        </Typography>
        <Typography variant="body2">
          {t('forms.remove-habit-schedule.message.warning')}
        </Typography>
      </Styled.Body>

      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          onClick={onCancel}
        >
          {t('forms.remove-habit-schedule.message.buttons.cancel.label')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onSubmit}>
          {t('forms.remove-habit-schedule.message.buttons.submit.label')}
        </Button>
      </Styled.Interactions>
    </>
  );
};
